import { UsagePanel } from "../../features/usage/UsagePanel";

export function ConsoleUsagePage() {
  return (
    <div className="console-page">
      <div className="console-page-head">
        <h1 className="console-page-title">Usage</h1>
        <p className="console-page-sub">
          Network and account usage. Values are placeholders until real telemetry and billing exist.
        </p>
      </div>
      <UsagePanel />
    </div>
  );
}
